import { useMemo } from "react";
import { isFeatureEnabled } from "../utlities/featureFlags";

/**
 * React hook wrapper over the feature-flag framework. Returns whether the given
 * registered flag is enabled in this build. Flags are build-time constants, so the
 * result is stable for a given key; the hook exists so components have one idiomatic
 * entry point (and a seam to make flags reactive later without touching call sites).
 * @param {string} flagKey one of the FEATURE_* constants from utlities/featureFlags
 * @returns {boolean}
 */
export default function useFeatureFlag(flagKey) {
  return useMemo(() => isFeatureEnabled(flagKey), [flagKey]);
}
